
import Vue from 'vue'
import Router from 'vue-router'

// import modules here
import RouteHome from './modules/RouteHome'

Vue.use(Router)

// register modules here
const moduleRoutes = [
  RouteHome,
]

const baseRoutes = [
  {
    path: '*',
    redirect: '/'
  }
]

const routes = baseRoutes.concat(...moduleRoutes)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
